<template>
  <div>
    <header-bar>
      届出内容{{ isEdit ? '編集' : '登録' }}
    </header-bar>
    <div class="page-block not-distributed-apply">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">届出内容</h3>
        <span
          v-if="isEditTrack || isDeliveredTrack()"
          class="delivered-song-label">
          配信済み
        </span>
      </div>
      <div class="page-block__inner">
        <form
          class="form--error"
          @submit.prevent="onNextClicked()">
          <p style="margin-bottom: 15px">
            <span class="req">＊</span> は必須項目です
          </p>
          <div class="">
            <div class="form-group-wrap__title copyright-main-title">
              <label
                class="control-label"
                for="title">
                作品タイトル
              </label>
            </div>
            <!-- TITLE START -->
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label
                  class="control-label"
                  for="title_ja">タイトル名
                  <span class="req">＊</span>
                  <span class="sub-text">（バージョン違いの作品はお預かりしていません）</span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="title_ja"
                  v-model.trim="copyRightForm.title_ja"
                  class="form-control"
                  :disabled="isDeliveredTrack()"
                  type="text"
                  @blur="onFieldChanged('title_ja')">
                <p
                  v-if="errors.title_ja"
                  class="error-text">
                  {{ errors.title_ja[0] }}
                </p>
              </div>
            </div>
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label
                  class="control-label"
                  for="title_kana">タイトル名（カナ表記）
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="title_kana"
                  v-model.trim="copyRightForm.title_kana"
                  class="form-control"
                  :disabled="isDeliveredTrack()"
                  type="text"
                  @blur="onFieldChanged('title_kana')">
                <p
                  v-if="errors.title_kana"
                  class="error-text">
                  {{ errors.title_kana[0] }}
                </p>
              </div>
            </div>
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label
                  class="control-label"
                  for="title_en">タイトル名（アルファベット表記）
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="form-item">
                <input
                  id="title_en"
                  v-model.trim="copyRightForm.title_en"
                  class="form-control"
                  :disabled="isDeliveredTrack()"
                  type="text"
                  @blur="onFieldChanged('title_en')">
                <p
                  v-if="errors.title_en"
                  class="error-text">
                  {{ errors.title_en[0] }}
                </p>
              </div>
            </div>
            <!-- TITLE END -->
            <div class="partition"></div>
            <!--MAIN ARTIST START-->
            <template>
              <div class="form-group-wrap form-group--copyright__no-padding-and-border">
                <div class="form-group-wrap__title">
                  <label class="control-label">
                    メインアーティスト
                    <span class="req">＊</span>
                  </label>
                </div>
                <selected-artist
                  :artists="copyRightForm.artists.main_artists"
                  :belongs-to="mainArtist"
                  @notify="handleRemovedDataFromChild">
                </selected-artist>
                <accordion
                  v-show="!isEditTrack"
                  :belongs-to="mainArtist"
                  :button-text="getButtonText('main_artists')"
                  @toggle="handleToggleAccordion" />
                <p
                  v-if="errors[`artists.main_artists`]"
                  class="error-text">
                  {{ errors[`artists.main_artists`][0] }}
                </p>
                <transition name="slide">
                  <div v-if="showAccordion && !isEditTrack">
                    <tabs
                      :active-tab="activeTab"
                      :belongs-to="mainArtist"
                      :tabs="tabs.artistTabs"
                      @tab-clicked="handleTabClicked" />
                    <div class="tab-container">
                      <template v-if="activeTab === 0">
                        <searchable-artist-list
                          :artists="mainArtistPagination"
                          :belongs-to="mainArtist"
                          :search-status="mainSearchStatus"
                          :last-page="artistLastPage"
                          @handle="handle"
                          @pagination="handlePagination"
                          @notify="handleSelectedDataFromChild"
                          @search="handleSearch">
                        </searchable-artist-list>
                      </template>
                      <template
                        v-if="activeTab === 1">
                        <artist-create
                          :belongs-to="mainArtist"
                          @cancel="cancelArtist"
                          @notify="handleSavedDataFromChild">
                        </artist-create>
                      </template>
                      <template v-if="activeTab === 2">
                        <searchable-vocaloid-list
                          :vocaloids="mainArtistVocaloidPagination"
                          :belongs-to="mainArtistVocaloid"
                          :search-status="mainSearchStatus"
                          :last-page="vocaloidLastPage"
                          @handle="handle"
                          @pagination="handlePagination"
                          @notify="handleSelectedDataFromChild"
                          @search="handleSearch">
                        </searchable-vocaloid-list>
                      </template>
                    </div>
                  </div>
                </transition>
              </div>
            </template>
            <!--MAIN ARTIST END-->
            <!--FEATURING ARTIST START-->
            <template>
              <div
                v-show="!isEditTrack"
                class="form-group-wrap form-group--copyright__no-padding-and-border">
                <div class="form-group-wrap__title">
                  <label class="control-label">
                    Featuringアーティスト
                  </label>
                  <i
                    v-tooltip="pcTooltipConfig(tooltipMessages.featuring_artists)"
                    class="tooltip-icon">
                  </i>
                  <div class="form-item">
                    <div class="form-item-inline">
                      <div class="radio">
                        <label for="featuring_artist_yes">
                          <input
                            id="featuring_artist_yes"
                            v-model="showFeaturing"
                            type="radio"
                            name="featuring_artist_yes"
                            :value="true">
                          <div class="option-input"></div>
                          あり
                        </label>
                      </div>
                      <div class="radio">
                        <label for="featuring_artist_no">
                          <input
                            id="featuring_artist_no"
                            v-model="showFeaturing"
                            type="radio"
                            name="featuring_artist_no"
                            :value="false"
                            @change="handleNoFeaturingArtists()">
                          <div class="option-input"></div>
                          なし
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <selected-artist
                  :artists="copyRightForm.artists.featuring_artists"
                  :belongs-to="featuringArtist"
                  @notify="handleRemovedDataFromChild">
                </selected-artist>
                <accordion
                  v-show="!isEditTrack && showFeaturing"
                  :belongs-to="featuringArtist"
                  :button-text="getButtonText('featuring_artists')"
                  @toggle="handleToggleAccordion" />
                <transition name="slide">
                  <div v-if="showFeaturingAccordion && !isEditTrack && showFeaturing">
                    <tabs
                      :active-tab="activeFeaturingTab"
                      :belongs-to="featuringArtist"
                      :tabs="tabs.artistTabs"
                      @tab-clicked="handleTabClicked" />
                    <div class="tab-container">
                      <template v-if="activeFeaturingTab === 0">
                        <searchable-feat-artist-list
                          :artists="featuringArtistPagination"
                          :belongs-to="featuringArtist"
                          :search-status="featSearchStatus"
                          :last-page="featArtistLastPage"
                          @handle="handle"
                          @pagination="handlePagination"
                          @notify="handleSelectedDataFromChild"
                          @search="handleSearch">
                        </searchable-feat-artist-list>
                      </template>
                      <template
                        v-if="activeFeaturingTab === 1">
                        <artist-create
                          :belongs-to="featuringArtist"
                          @cancel="cancelArtist"
                          @notify="handleSavedDataFromChild">
                        </artist-create>
                      </template>
                      <template v-if="activeFeaturingTab === 2">
                        <searchable-feat-vocaloid-list
                          :vocaloids="featuringArtistVocaloidPagination"
                          :belongs-to="featuringArtistVocaloid"
                          :search-status="featSearchStatus"
                          :last-page="featVocaloidLastPage"
                          @handle="handle"
                          @pagination="handlePagination"
                          @notify="handleSelectedDataFromChild"
                          @search="handleSearch">
                        </searchable-feat-vocaloid-list>
                      </template>
                    </div>
                  </div>
                </transition>
              </div>
            </template>
            <!--FEATURING ARTIST END-->
            <div class="partition"></div>
            <div
              class="form-group
                form-group--copyright__no-padding-and-border
                instrumental-checkbox">
              <div class="form-label custom-instrumental-width">
                <label class="control-label">
                  <b>この作品はインストゥルメンタルです。</b>
                  <i
                    v-tooltip="pcTooltipConfig(tooltipMessages.instrumental)"
                    class="tooltip-icon">
                  </i>
                </label>
              </div>
              <div class="form-item">
                <div
                  class="checkbox"
                  style="display: unset">
                  <label>
                    <input
                      v-model="copyRightForm.is_instrumental"
                      type="checkbox"
                      :disabled="isDeliveredTrack()"
                      value="0"
                      @change="toggleInstrumentalCheckbox">
                    <div
                      :class="{ 'disabled-checkbox': isDeliveredTrack()}"
                      class="option-input">
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label
                  class="control-label"
                  for="play_time_min">演奏時間
                  <span class="req">＊</span>
                </label>
              </div>
              <div class="">
                <div class="form-item">
                  <div class="">
                    <span class="form-item__wrap">
                      <input
                        id="play_time_min"
                        v-model="copyRightForm.play_time_min"
                        class="form-control form-control--time"
                        :disabled="isDeliveredTrack()"
                        max="59"
                        min="0"
                        type="number">分
                    </span>
                    <span class="form-item__wrap">
                      <input
                        id="play_time_sec"
                        v-model="copyRightForm.play_time_sec"
                        class="form-control form-control--time"
                        :disabled="isDeliveredTrack()"
                        max="59"
                        min="0"
                        type="number">秒
                    </span>
                  </div>
                  <p
                    v-if="errors.play_time_min && errors.play_time_sec"
                    class="error-text">
                    {{ errors.play_time_min[0] }}
                  </p>
                  <p
                    v-else-if="errors.play_time_min"
                    class="error-text">
                    {{ errors.play_time_min[0] }}
                  </p>
                  <p
                    v-else-if="errors.play_time_sec"
                    class="error-text">
                    {{ errors.play_time_sec[0] }}
                  </p>
                </div>
              </div>
            </div>
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label class="control-label">
                  発売日
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="pcTooltipConfig(tooltipMessages.release_date)"
                  class="tooltip-icon">
                </i>
              </div>
              <div
                class="form-item">
                <date-picker
                  v-model="copyRightForm.released_date"
                  :default-value="new Date()"
                  :editable="false"
                  value-type="format">
                </date-picker>
              </div>
              <p
                v-if="errors.released_date"
                class="error-text">
                {{ errors.released_date[0] }}
              </p>
            </div>
            <div class="form-group form-group--copyright">
              <div class="form-label form-label--copyright">
                <label
                  class="control-label"
                  for="label_name">
                  レーベル名
                </label>
              </div>
              <div class="form-item">
                <input
                  id="label_name"
                  v-model.trim="copyRightForm.label_name"
                  class="form-control"
                  :disabled="isDeliveredTrack()"
                  type="text"
                  value="">
              </div>
            </div>
            <div class="partition"></div>
            <!--AUTHOR START-->
            <div
              :class="{'pb-0': showAuthorAccordion}"
              class="form-group-wrap border-none">
              <div class="form-group-wrap__title">
                <label class="control-label">
                  著作者
                  <span class="req">＊</span>
                </label>
                <i
                  v-tooltip="pcTooltipConfig(tooltipMessages.authors)"
                  class="tooltip-icon">
                </i>
              </div>
              <div v-if="hasAuthors">
                <div
                  v-for="(item, index) in copyRightForm.authors"
                  :key="`${item.id}-${index}`">
                  <author-create
                    v-if="isEditTrack"
                    :author-form="item"
                    :create="true"
                    :index="index"
                    :is-edit-track="isEditTrack"
                    :author-errors="authorErrors"
                    :is-instrumental="copyRightForm.is_instrumental"
                    @notify-cancel="handleCancelAuthor"
                    @notify-edit="handleEditAuthor"
                    @notify-save="handleSavedDataFromChild"
                    @notify-remove="handleRemovedDataFromChild"
                    @notify-value-update="handleValueUpdate"
                    @notify-role-update="handleAuthorRolesUpdate" />
                  <author-create
                    v-else
                    :author-form="item"
                    :create="false"
                    :index="index"
                    :author-errors="authorErrors"
                    :is-instrumental="copyRightForm.is_instrumental"
                    @notify-cancel="handleCancelAuthor"
                    @notify-edit="handleEditAuthor"
                    @notify-save="handleSavedDataFromChild"
                    @notify-remove="handleRemovedDataFromChild"
                    @notify-role-update="handleAuthorRolesUpdate" />
                </div>
              </div>
              <accordion
                :belongs-to="author"
                :button-text="getButtonText('authors')"
                @toggle="handleToggleAccordion" />
              <p
                v-if="errors.authors"
                class="error-text">
                {{ errors.authors[0] }}
              </p>
              <transition name="slide">
                <div v-if="showAuthorAccordion">
                  <tabs
                    :active-tab="activeAuthorTab"
                    :belongs-to="author"
                    :tabs="tabs.authorTabs"
                    @tab-clicked="handleTabClicked" />
                  <div class="tab-container author-section">
                    <template
                      v-if="activeAuthorTab === 0">
                      <searchable-author-list
                        :authors="authorPagination"
                        :search-status="authorSearchStatus"
                        :belongs-to="author"
                        @pagination="handlePagination"
                        @notify="handleSelectedDataFromChild"
                        @search="handleSearch">
                      </searchable-author-list>
                    </template>
                    <template
                      v-if="activeAuthorTab === 1">
                      <author-create
                        :author-form="authorForm"
                        :belongs-to="author"
                        :create="true"
                        :hide-role="true"
                        :author-errors="authorErrors"
                        :form-validated="authorFormValidated"
                        @notify-save="handleSavedDataFromChild" />
                    </template>
                  </div>
                </div>
              </transition>
            </div>
            <!--AUTHOR END-->
          </div>
          <div>
            <alert-view
              :errors="errors">
            </alert-view>
            <div
              v-if="isEdit || isEditTrack"
              class="c-btn-wrap">
              <a
                class="c-btn c-btn--back c-btn--back-left"
                type="submit"
                @click.prevent="onReturnClicked()">
                一覧へ戻る
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </a>
              <a
                :class="{ 'c-btn--off' : hasEditedAuthor || !isEnabledCopyrightOperation() }"
                :disabled="hasEditedAuthor || !isEnabledCopyrightOperation()"
                class="c-btn"
                type="submit"
                @click.prevent="onNextClicked()">
                内容を確認する
                <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
              </a>
            </div>
            <div
              v-else
              class="c-btn-wrap">
              <button
                :class="{ 'c-btn--off' : hasEditedAuthor || !isEnabledCopyrightOperation()
                  || companyTier === companyTierC}"
                class="c-btn"
                :disabled="hasEditedAuthor
                  || !isEnabledCopyrightOperation()
                  || companyTier === companyTierC"
                @click.prevent="onNextClicked()">
                内容を確認する
                <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'
import Accordion from './Common/Accordion'
import AuthorCreate from './Author/AuthorCreate'
import HeaderBar from '../HeaderBar'
import Tabs from './Common/Tabs'
import ArtistCreate from './Common/ArtistCreate'
import SelectedArtist from './Common/SelectedArtist'
import SearchableArtistList from './Common/SearchableArtistList'
import SearchableFeatArtistList from './Common/SearchableFeatArtistList'
import SearchableVocaloidList from './Common/SearchableVocaloidList'
import SearchableFeatVocaloidList from './Common/SearchableFeatVocaloidList'
import SearchableAuthorList from './Common/SearchableAuthorList'
import {
  CMAP_RELEASE_STATUS_DSP_IN_REVIEW,
  CMAP_RELEASE_STATUS_PUBLISHED,
} from '../../../consts/status'
import {
  ARTIST,
  AUTHOR,
  FEATURING_ARTIST,
  FEATURING_ARTIST_VOCALOID,
  MAIN_ARTIST,
  MAIN_ARTIST_VOCALOID,
  VOCALOID,
} from './consts'
import { DISTRIBUTED_AUTHOR, NON_DISTRIBUTED_AUTHOR } from './uiStates'
import AlertView from '../AlertView'
import tooltipMessages from './copyright-tooltips'
import tooltip from '../../mixins/tooltip'

let vTimer = null
export default {
  name: 'CopyrightCreate',
  components: {
    AlertView,
    SearchableAuthorList,
    ArtistCreate,
    Accordion,
    AuthorCreate,
    SearchableArtistList,
    SearchableFeatArtistList,
    SearchableVocaloidList,
    SearchableFeatVocaloidList,
    DatePicker,
    HeaderBar,
    SelectedArtist,
    Tabs,
  },
  mixins: [
    tooltip,
  ],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    isEditTrack: {
      type: Boolean,
      default: false,
    },
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
  },
  data() {
    return {
      deliveredTrackAuthor: [],
      mainSearchStatus: -1,
      featSearchStatus: -1,
      authorSearchStatus: -1,
      copyRightForm: {
        title_ja: '',
        title_kana: '',
        title_en: '',
        artists: {
          main_artists: [],
          featuring_artists: [],
        },
        authors: [],
        is_instrumental: false,
        play_time_min: 0,
        play_time_sec: 0,
        released_date: moment().format('YYYY-MM-DD'),
        label_name: '',
        product_disc_track_id: '',
        status: 0,
        type: 1,
      },
      authorForm: {
        id: '',
        name_ja: '',
        name_kana: '',
        name_en: '',
        author_meta: {
          email: '',
          is_group: false,
          is_owner: true,
          personal_meta: {
            real_name: {
              ja: { name: '' },
              en: { name: '' },
            },
            is_jasrac_member: false,
          },
          group_meta: [],
        },
        pivot: {
          author_roles: this.getRoles(),
        },
        operation: NON_DISTRIBUTED_AUTHOR.CREATE_UI,
        isTrackAuthor: false,
        rate: 0,
      },
      artistForm: {
        type: 1,
        name_ja: '',
        name_kana: '',
        name_en: '',
        url: '',
        blog: '',
        genre_ja: '',
        genre_en: '',
        area_ja: '',
        area_en: '',
        profile_ja: '',
        profile_en: '',
        confirmed: true,
      },
      showAccordion: false,
      showAuthorAccordion: false,
      showFeaturingAccordion: false,
      activeTab: 0,
      activeAuthorTab: 0,
      activeFeaturingTab: 0,
      editedAuthors: [],
      selectedAuthors: [],
      mainArtistPagination: [],
      featuringArtistPagination: [],
      mainArtistVocaloidPagination: [],
      featuringArtistVocaloidPagination: [],
      authorPagination: {
        data: [],
        per_page: 10,
      },
      tabs: {
        artistTabs: [
          { title: 'マイアーティスト' },
          { title: '新規登録' },
          { title: 'VOCALOID/その他音声合成ソフト' },
        ],
        authorTabs: [
          { title: 'マイ著作者' },
          { title: '新規登録' },
        ],
      },
      errors: {},
      authorErrors: {},
      authorRoleErrors: {},
      mainArtist: MAIN_ARTIST,
      featuringArtist: FEATURING_ARTIST,
      mainArtistVocaloid: MAIN_ARTIST_VOCALOID,
      featuringArtistVocaloid: FEATURING_ARTIST_VOCALOID,
      author: AUTHOR,
      isAddingForMainArtist: false,
      isAddingForFeaturingArtist: false,
      trackAlreadyActiveAuthorFormFields: [],
      authorFormValidated: false,
      artistLastPage: false,
      featArtistLastPage: false,
      vocaloidLastPage: false,
      featVocaloidLastPage: false,
      showFeaturing: false,
      isCoLyricistSelected: false,
      isCoComposerSelected: false,
      selectedAuthorEmails: [],
      isCoLyricistRemoved: false,
      isCoComposerRemoved: false,
      companyTierC: 'C',
      companyTier: '',
    }
  },
  computed: {
    hasAuthors() {
      return this.copyRightForm.authors.length > 0
    },
    hasEditedAuthor() {
      return this.editedAuthors.length > 0
    },
  },
  /* eslint-disable */
  watch: {
    isCoLyricistSelected(newVal) {
      const selectedAuthorsCount = this.copyRightForm.authors.length > 1
      // true case: disable
      if (selectedAuthorsCount && newVal) {
        const currentCoLyricistSelectedAuthor = this.copyRightForm.authors
          .find(author => author.pivot.author_roles
            .some(role => role.value === 'co-lyricist' && role.checked))
        this.copyRightForm.authors.forEach((author) => {
          if (author.id !== currentCoLyricistSelectedAuthor.id) {
            /* eslint-disable no-param-reassign */
            author.pivot.author_roles.forEach(role => {
              if (role.value === 'co-lyricist') {
                role.checked = false
                role.disabled = true
              }
            })
            /* eslint-enable no-param-reassign */
          }
        })
      }
      // false case: enable
      if (selectedAuthorsCount && !newVal) {
        this.copyRightForm.authors.forEach((author) => {
          const lyricist = author.pivot.author_roles.find(currentRole => currentRole.value === 'lyricist');
          /* eslint-disable no-param-reassign */
          author.pivot.author_roles.forEach(role => {
            if (role.value === 'co-lyricist') {
              role.checked = false
              role.disabled = !!lyricist.checked || false
            }
          })
          /* eslint-enable no-param-reassign */
        })
      }
    },
    isCoComposerSelected(newVal) {
      const selectedAuthorsCount = this.copyRightForm.authors.length > 1
      // true case: disable
      if (selectedAuthorsCount && newVal) {
        const currentCoComposerSelectedAuthor = this.copyRightForm.authors
          .find(author => author.pivot.author_roles
            .some(role => role.value === 'co-composer' && role.checked))
        this.copyRightForm.authors.forEach((author) => {
          if (author.id !== currentCoComposerSelectedAuthor.id) {
            /* eslint-disable no-param-reassign */
            author.pivot.author_roles.forEach(role => {
              if (role.value === 'co-composer') {
                role.checked = false
                role.disabled = true
              }
            })
            /* eslint-enable no-param-reassign */
          }
        })
      }
      // false case: enable
      if (selectedAuthorsCount && !newVal) {
        this.copyRightForm.authors.forEach((author) => {
          const composer = author.pivot.author_roles.find(currentRole => currentRole.value === 'composer');
          /* eslint-disable no-param-reassign */
          author.pivot.author_roles.forEach(role => {
            if (role.value === 'co-composer') {
              role.checked = false
              role.disabled = !!composer.checked || false
            }
          })
          /* eslint-enable no-param-reassign */
        })
      }
    },
    'copyRightForm.is_instrumental': function (newVal) {
      const selectedAuthorsCount = this.copyRightForm.authors.length > 0
      // case true: checked
      if (newVal && selectedAuthorsCount) {
        this.copyRightForm.authors.forEach((author, index) => {
          this.copyRightForm.authors[index].pivot = {
            ...author.pivot,
            author_roles: author.pivot.author_roles.map(role => {
              if (role.value === 'co-lyricist' || role.value === 'lyricist') {
                return { ...role, disabled: newVal, checked: false }
              }
              return role
            }),
          }
        })
      }
      // case false: unchecked
      if (!newVal && selectedAuthorsCount) {
        this.copyRightForm.authors.forEach((author) => {
          /* eslint-disable no-param-reassign */
          author.pivot.author_roles.forEach(role => {
            if (role.value === 'lyricist' || role.value === 'co-lyricist') {
              role.checked = false
              role.disabled = false
            }
          })
          /* eslint-enable no-param-reassign */
        })
      }
      this.calculateRate()
    },
    isCoLyricistRemoved(newVal) {
      const selectedAuthorsCount = this.copyRightForm.authors.length > 0
      if (selectedAuthorsCount && newVal) {
        this.copyRightForm.authors.forEach((author) => {
          /* eslint-disable no-param-reassign */
          author.pivot.author_roles.forEach(role => {
            if (role.value === 'co-lyricist') {
              role.checked = false
              role.disabled = false
            }
          })
          /* eslint-enable no-param-reassign */
        })
      }
    },
    isCoComposerRemoved(newVal) {
      const selectedAuthorsCount = this.copyRightForm.authors.length > 0
      if (selectedAuthorsCount && newVal) {
        this.copyRightForm.authors.forEach((author) => {
          /* eslint-disable no-param-reassign */
          author.pivot.author_roles.forEach(role => {
            if (role.value === 'co-composer') {
              role.checked = false
              role.disabled = false
            }
          })
          /* eslint-enable no-param-reassign */
        })
      }
    },
  },
  /* eslint-enable */
  async mounted() {
    this.companyTier = this.$store.state.auth.company.tier
    await this.getArtist()
    await this.getAuthors()
    // when added copyrights action is clicked
    if (this.isEdit) {
      const { data } = await this.getCopyrights(this.$route.params.id)
      if (data.data.length === 0) {
        this.$router.push({ name: 'copyright-index' })
      }
      const copyrights = data.data[0]
      const authors = []
      if (copyrights.authors.length === 0) {
        return
      }
      copyrights.authors.forEach(author => {
        const newAuthor = { ...author }
        if (author.pivot.is_track_author) {
          newAuthor.operation = DISTRIBUTED_AUTHOR.ON_EDIT_DISPLAY_SAVED_AUTHOR_UI
          this.deliveredTrackAuthor.push(newAuthor.name_ja)
        } else {
          newAuthor.operation = NON_DISTRIBUTED_AUTHOR.DISPLAY_SAVED_AUTHOR_UI
        }
        authors.push(newAuthor)
      })
      copyrights.authors = authors
      const [playTimeMin, playTimeSec] = copyrights.play_time.split(':')
      copyrights.play_time_min = playTimeMin
      copyrights.play_time_sec = playTimeSec
      copyrights.is_instrumental = copyrights.is_instrumental === 1
      this.copyRightForm = copyrights
      this.calculateRate()
      this.isDeliveredTrack()
      this.handleFilterItems(ARTIST)
      this.handleFilterItems(VOCALOID)
      this.handleFilterItems(AUTHOR)
    }
    // when delivered status track's action is clicked
    if (this.isEditTrack) {
      this.showAccordion = true
      const { data } = await this.getTrackDetails(this.$route.params.id)
      const copyrights = data[0]

      copyrights.artists = JSON.parse(copyrights.artists) || []
      copyrights.artists.main_artists = copyrights.artists.main_artists
        .map((artist) => ({ ...artist, isRemovable: false }))
      if (copyrights.artists.featuring_artists) {
        copyrights.artists.featuring_artists = copyrights.artists.featuring_artists
          .map((artist) => ({ ...artist, isRemovable: false }))
      }
      copyrights.is_instrumental = copyrights.pdt_version && copyrights.pdt_version.length > 0
      /* eslint-disable no-unused-vars */
      const [playTimeHour, playTimeMin, playTimeSec] = copyrights.duration.split(':')
      /* eslint-enable no-unused-vars */
      copyrights.play_time_min = playTimeMin
      copyrights.play_time_sec = playTimeSec
      copyrights.released_date = copyrights.released_date || moment().format('YYYY-MM-DD')
      copyrights.type = 0
      const copyrightAuthors = []
      copyrights.artists.copyright_artists.forEach(author => {
        // If the roles array contains only 'arranger' then ignore
        if (author.roles.length === 1 && author.roles[0] === 'arranger') {
          return
        }
        const newAuthor = { ...author }
        const checkExistsInauthor = copyrights.authors
          .filter(existingAuthor => existingAuthor.name_ja === newAuthor.name_ja)
        if (checkExistsInauthor.length !== 0) {
          checkExistsInauthor.forEach(currAuthor => {
            const savedAuthor = { ...currAuthor }
            savedAuthor.isTrackAuthor = true
            savedAuthor.pivot = {
              author_roles: this.getRoles(),
            }
            savedAuthor.operation = DISTRIBUTED_AUTHOR.POST_SELECTED_UI
            copyrightAuthors.push(savedAuthor)
            this.deliveredTrackAuthor.push(savedAuthor.name_ja)
          })
        } else {
          newAuthor.pivot = {
            author_roles: this.getRoles(),
          }
          newAuthor.pivot.author_roles = newAuthor.pivot.author_roles.map(role => ({
            ...role,
            checked: newAuthor.roles.includes(role),
          }))
          delete newAuthor.roles
          newAuthor.operation = DISTRIBUTED_AUTHOR.DISPLAY_SAVED_AUTHOR_UI
          const currentAuthor = { ...this.authorForm, ...newAuthor }
          currentAuthor.isTrackAuthor = true
          copyrightAuthors.push(currentAuthor)
          this.resetAuthorForm()
          this.editedAuthors.push(currentAuthor)
          this.selectedAuthors.push(JSON.stringify(currentAuthor))
          this.deliveredTrackAuthor.push(currentAuthor.name_ja)
        }
      })
      copyrights.authors = copyrightAuthors
      this.copyRightForm = copyrights
      this.calculateRate()
      this.handleFilterItems(ARTIST)
      this.handleFilterItems(VOCALOID)
      this.handleFilterItems(AUTHOR)
      this.retrieveSelectedAuthorsEmail()
    }
  },
  methods: {
    handle(belongsTo) {
      switch (belongsTo) {
        case MAIN_ARTIST:
          this.artistLastPage = false
          break
        case FEATURING_ARTIST:
          this.featArtistLastPage = false
          break
        case MAIN_ARTIST_VOCALOID:
          this.vocaloidLastPage = false
          break
        case FEATURING_ARTIST_VOCALOID:
          this.featVocaloidLastPage = false
          break
        default:
      }
    },
    cancelArtist(belongsTo) {
      switch (belongsTo) {
        case MAIN_ARTIST:
          this.showAccordion = false
          break
        case FEATURING_ARTIST:
          this.showFeaturingAccordion = false
          break
        default:
      }
    },
    /**
     * Validate the input field on blur event
     * @param key - field name
     */
    onFieldChanged(key = '') {
      if (vTimer) {
        clearTimeout(vTimer)
      }
      vTimer = setTimeout(() => { this.onNextClicked(key) }, 10)
    },
    /**
     * Filter the selected artist or vocaloid from the original data based on the type.
     * @param {string} belongsTo - The type of the selected artist or vocaloid.
     */
    handleFilterItems(belongsTo) {
      const mainArtistsIDs = new Set(this.copyRightForm.artists.main_artists.map(
        artist => artist.id,
      ))
      const featArtistsIDs = new Set(this.copyRightForm.artists.featuring_artists.map(
        artist => artist.id,
      ))

      switch (belongsTo) {
        case MAIN_ARTIST:
        case FEATURING_ARTIST:
        case ARTIST:
          this.mainArtistPagination = this.mainArtistPagination
            .filter(
              artist => !mainArtistsIDs.has(artist.id) && !featArtistsIDs.has(artist.id),
            )
          this.featuringArtistPagination = this.featuringArtistPagination
            .filter(
              artist => !mainArtistsIDs.has(artist.id) && !featArtistsIDs.has(artist.id),
            )
          break
        case MAIN_ARTIST_VOCALOID:
        case FEATURING_ARTIST_VOCALOID:
        case VOCALOID:
          this.mainArtistVocaloidPagination = this.mainArtistVocaloidPagination
            .filter(
              vocaloid => !mainArtistsIDs.has(vocaloid.id) && !featArtistsIDs.has(vocaloid.id),
            )
          this.featuringArtistVocaloidPagination = this.featuringArtistVocaloidPagination
            .filter(
              vocaloid => !mainArtistsIDs.has(vocaloid.id) && !featArtistsIDs.has(vocaloid.id),
            )
          break
        case AUTHOR: {
          const uniqueAuthors = new Set(this.copyRightForm.authors.map(author => author.name_ja))
          this.authorPagination.data = this.authorPagination.data.filter(
            author => !uniqueAuthors.has(author.name_ja),
          )
          break
        }
        default:
      }
    },
    /**
     * Filter out the selected artist or vocaloid from the existing original data based on the type.
     * @param {object} data - data of entity
     * @param {string} belongsTo - The type of the selected artist or vocaloid.
     */
    filterOutSelectedData({ data, belongsTo }) {
      switch (belongsTo) {
        case MAIN_ARTIST:
        case FEATURING_ARTIST:
          this.mainArtistPagination = this.mainArtistPagination.filter(
            (artist) => artist.id !== data.id,
          )
          this.featuringArtistPagination = this.mainArtistPagination
          break
        case MAIN_ARTIST_VOCALOID:
        case FEATURING_ARTIST_VOCALOID:
          this.mainArtistVocaloidPagination = this.mainArtistVocaloidPagination.filter(
            (vocaloid) => vocaloid.id !== data.id,
          )
          this.featuringArtistVocaloidPagination = this.mainArtistVocaloidPagination
          break
        case AUTHOR:
          this.authorPagination.data = this.authorPagination.data.filter(
            (author) => author.name_ja !== data.name_ja,
          )
          break
        default:
      }
    },
    /**
     * Toggle the accordion of artist or vocaloid or author.
     * @param {string} belongsTo - The type of the selected artist or vocaloid or author.
     */
    async handleToggleAccordion(belongsTo) {
      switch (belongsTo) {
        case MAIN_ARTIST:
        case MAIN_ARTIST_VOCALOID:
          this.activeTab = 0
          this.showAccordion = !this.showAccordion
          break
        case FEATURING_ARTIST:
        case FEATURING_ARTIST_VOCALOID:
          this.activeFeaturingTab = 0
          this.showFeaturingAccordion = !this.showFeaturingAccordion
          break
        case AUTHOR: {
          this.activeAuthorTab = 0
          this.showAuthorAccordion = !this.showAuthorAccordion
          break
        }
        default:
      }
    },
    /**
     * Toggle the accordion of artist or vocaloid or author after save, update or select.
     * @param {string} belongsTo - The type of the selected artist or vocaloid or author.
     * @param {boolean} show - flag to show accordion
     */
    async handleToggleAccordionAfterOperation(belongsTo, show = false) {
      switch (belongsTo) {
        case MAIN_ARTIST:
        case MAIN_ARTIST_VOCALOID:
          this.activeTab = 0
          this.showAccordion = show
          if (
            (this.mainSearchStatus === 0 || this.mainSearchStatus === 1)
            && this.showAccordion
          ) {
            await this.getArtist({ belongsTo: MAIN_ARTIST })
          }
          break
        case FEATURING_ARTIST:
        case FEATURING_ARTIST_VOCALOID:
          this.activeFeaturingTab = 0
          this.showFeaturingAccordion = show
          if (
            (this.featSearchStatus === 0 || this.featSearchStatus === 1)
            && this.showFeaturingAccordion
          ) {
            await this.getArtist({ belongsTo: FEATURING_ARTIST })
          }
          break
        case AUTHOR: {
          this.activeAuthorTab = 0
          this.showAuthorAccordion = show
          if (
            (this.authorSearchStatus === 0 || this.authorSearchStatus === 1)
            && this.showAuthorAccordion
          ) {
            await this.getAuthors()
          }
          break
        }
        default:
      }
    },
    /**
     * Handle search done for artist or vocaloid or author.
     * @param {string} keyword - searched text.
     * @param {string} belongsTo - representing the entity
     * (e.g., artist, vocaloid, author) for which the current operation is being performed
     */
    async handleSearch({ keyword, belongsTo }) {
      switch (belongsTo) {
        case MAIN_ARTIST: {
          this.mainArtistPagination = []
          await this.getArtist({ belongsTo: MAIN_ARTIST, searchText: keyword })
          break
        }
        case MAIN_ARTIST_VOCALOID: {
          this.mainArtistVocaloidPagination = []
          await this.getVocaloid({ belongsTo: MAIN_ARTIST, searchText: keyword })
          break
        }
        case FEATURING_ARTIST: {
          this.featuringArtistPagination = []
          await this.getArtist({ belongsTo: FEATURING_ARTIST, searchText: keyword })
          break
        }
        case FEATURING_ARTIST_VOCALOID: {
          this.featuringArtistVocaloidPagination = []
          await this.getVocaloid({ belongsTo: FEATURING_ARTIST, searchText: keyword })
          break
        }
        case AUTHOR: {
          await this.getAuthors({ searchText: keyword })
          break
        }
        default:
      }
    },
    /**
     * Handle deleted item that could be artist or vocaloid or author.
     * @param {string} data - data being deleted
     * @param {string} belongsTo - representing the entity
     * (e.g., artist, vocaloid, author) for which the current operation is being performed
     */
    handleRemovedDataFromChild({ data, belongsTo }) {
      switch (belongsTo) {
        case MAIN_ARTIST: {
          const mainArtists = this.copyRightForm.artists.main_artists
          const index = mainArtists.findIndex(artist => artist.id === data.id)
          if (index !== -1) {
            mainArtists.splice(index, 1)
          }
          this.restoreData(data)
          break
        }
        case FEATURING_ARTIST: {
          const featuringArtists = this.copyRightForm.artists.featuring_artists
          const index = featuringArtists.findIndex(artist => artist.id === data.id)
          if (index !== -1) {
            featuringArtists.splice(index, 1)
          }
          this.restoreData(data)
          break
        }
        case AUTHOR: {
          const author = this.copyRightForm.authors
          const index = author.findIndex(item => item.name_ja === data.name_ja)
          if (index !== -1) {
            const checkCoAuthor = author[index]
            if (checkCoAuthor.pivot && checkCoAuthor.pivot.author_roles.some(role => role.value === 'co-lyricist' && role.checked)) {
              this.isCoLyricistRemoved = true
              this.isCoLyricistSelected = false
            }
            if (checkCoAuthor.pivot && checkCoAuthor.pivot.author_roles.some(role => role.value === 'co-composer' && role.checked)) {
              this.isCoComposerRemoved = true
              this.isCoComposerSelected = false
            }
            author.splice(index, 1)
            this.calculateRate()
          }
          this.authorPagination.data.push(data)
          if (author.length === 0) {
            this.editedAuthors = []
            this.selectedAuthors = []
            this.selectedAuthorEmails = []
          } else {
            this.handleAuthorBeingEdited({ author: data })
            const sAuthor = this.selectedAuthors
            const sIndex = sAuthor
              .findIndex(cAuthor => JSON.parse(cAuthor).name_ja === data.name_ja)
            if (sIndex !== -1) {
              sAuthor.splice(sIndex, 1)
            }
            const { email } = data.author_meta
            const emailIndex = this.selectedAuthorEmails.indexOf(email)
            if (emailIndex !== -1) {
              this.selectedAuthorEmails.splice(emailIndex, 1)
            }
          }
          break
        }
        default:
      }
    },
    /**
     * Handle deleted item that could be artist or vocaloid or author.
     * @param {string} data - data being deleted.
     * @param {string} belongsTo - representing the entity
     * @param {string} refreshList - fetch data after save
     * (e.g., artist, vocaloid, author) for which the current operation is being performed
     */
    async handleSavedDataFromChild({
      data, belongsTo, formKey, currIndex,
    }) {
      switch (belongsTo) {
        case MAIN_ARTIST: {
          const artist = { ...data, isRemovable: true }
          this.copyRightForm.artists.main_artists.push(artist)
          this.handleToggleAccordionAfterOperation(MAIN_ARTIST)
          break
        }
        case FEATURING_ARTIST: {
          const artist = { ...data, isRemovable: true }
          this.copyRightForm.artists.featuring_artists.push(artist)
          this.handleToggleAccordionAfterOperation(FEATURING_ARTIST)
          break
        }
        case AUTHOR: {
          let errors = {}
          if (!data.author_meta.is_owner) {
            if (this.$store.state.auth.email === data.author_meta.email) {
              errors = {
                'author_meta.email': [
                  `著作者メールアドレスに${this.$store.state.auth.email}利用できません。`,
                ],
              }
            }
            if (Object.keys(errors).length > 0) {
              // reformat keys
              this.authorErrors = Object.keys(errors).reduce((acc, key) => {
                const newKey = `auth.${currIndex}.${key}`
                acc[newKey] = errors[key]
                return acc
              }, {})
              return
            }
          }
          if (data.id) {
            const response = await this.updateAuthor(data, formKey, currIndex)
            // During edit prevent transition of UI
            if (response.status && response.status === 422) {
              return
            }
          } else {
            this.authorErrors = {}
            const { data: response } = await this.saveAuthor(data, formKey, currIndex)
            // During edit prevent transition of UI
            if (response.status && response.status === 422) {
              return
            }

            if (Object.keys(this.authorErrors).length === 0) {
              this.handleToggleAccordionAfterOperation(AUTHOR)
              this.resetAuthorForm()
              this.editedAuthors = []
            }
          }
          this.handleAuthorBeingEdited({ author: data })
          const sAuthor = this.selectedAuthors
          const sIndex = sAuthor.findIndex(cAuthor => JSON.parse(cAuthor).name_ja === data.name_ja)
          if (sIndex !== -1) {
            sAuthor.splice(sIndex, 1)
            sAuthor.push(JSON.stringify(data))
          }
          break
        }
        default:
      }
    },
    async updateAuthor(form, formKey, currIndex) {
      const {
        pivot,
        operation,
        isTrackAuthor,
        ...authorForm
      } = form
      const newOperation = isTrackAuthor
        ? DISTRIBUTED_AUTHOR.POST_SAVE_UI
        : NON_DISTRIBUTED_AUTHOR.POST_SAVE_UI
      let updateResponse = ''
      try {
        const config = { headers: { 'X-CMAP-No-Loading': 1 } }
        const endPoint = formKey ? `/api/client/authors/${authorForm.id}?form_validate_only=1` : `/api/client/authors/${authorForm.id}`
        const { data: response } = await window.axios.put(endPoint, authorForm, config)
        if (response && response.length === 0) {
          this.deleteAuthorError(`auth.${currIndex}.${formKey}`)

          return { data: { status: 422 } }
        }
        const index = this.copyRightForm.authors
          .findIndex(obj => obj.name_ja === authorForm.name_ja)
        this.copyRightForm.authors[index].operation = newOperation
        if (formKey) {
          this.authorErrors = {}
        }
        updateResponse = { data: response }
      } catch ({ response }) {
        updateResponse = { data: { status: response.status } }
        this.trackAlreadyActiveAuthorFormFields.push(`auth.${currIndex}.${formKey}`)
        const { errors } = response.data
        // reformat keys
        const newErrors = Object.keys(errors).reduce((acc, key) => {
          const newKey = `auth.${currIndex}.${key}`
          acc[newKey] = errors[key]
          return acc
        }, {})
        if (formKey && !newErrors.status) {
          this.trackAlreadyActiveAuthorFormFields.forEach(key => {
            if (Object.keys(newErrors).includes(key)) {
              this.$set(this.authorErrors, key, newErrors[key])
            }
          })
        } else {
          this.authorErrors = newErrors
        }
      }
      return updateResponse
    },
    async saveAuthor(form, formKey, currIndex) {
      const {
        pivot,
        operation,
        isTrackAuthor,
        ...authorForm
      } = form
      const newOperation = isTrackAuthor
        ? DISTRIBUTED_AUTHOR.POST_SAVE_UI
        : NON_DISTRIBUTED_AUTHOR.POST_SAVE_UI
      let saveResponse = ''
      try {
        const config = { headers: { 'X-CMAP-No-Loading': 1 } }
        const endPoint = formKey ? '/api/client/authors?form_validate_only=1' : '/api/client/authors'
        const { data: response } = await window.axios.post(endPoint, authorForm, config)
        // During edit prevent transition of UI
        if (response && response.length === 0) {
          this.authorFormValidated = true
          return { data: { status: 422 } }
        }
        if (!isTrackAuthor) {
          // in case of non-distributed author
          authorForm.id = response.id
          authorForm.operation = newOperation
          authorForm.pivot = { author_roles: this.getRoles() }
          this.copyRightForm.authors.push(authorForm)
        } else {
          // for saving distributed author
          const index = this.copyRightForm.authors
            .findIndex(obj => obj.name_ja === authorForm.name_ja)
          this.copyRightForm.authors[index].id = response.id
          this.copyRightForm.authors[index].operation = newOperation
          this.deliveredTrackAuthor.push(authorForm.name_ja)
        }
        if (this.copyRightForm.is_instrumental) {
          this.checkAndDisableLyricistAndCoLyricist()
          this.removeCheckedRolesIfInstrumentalChecked()
        }
        if (formKey) {
          this.authorErrors = {}
        }
        saveResponse = { data: response }
      } catch ({ response }) {
        saveResponse = { data: { status: response.status } }
        this.trackAlreadyActiveAuthorFormFields.push(`auth.${currIndex}.${formKey}`)
        const { errors } = response.data
        // reformat keys
        const newErrors = Object.keys(errors).reduce((acc, key) => {
          const newKey = `auth.${currIndex}.${key}`
          acc[newKey] = errors[key]
          return acc
        }, {})
        if (formKey && !newErrors.status) {
          this.trackAlreadyActiveAuthorFormFields.forEach(key => {
            if (Object.keys(newErrors).includes(key)) {
              this.$set(this.authorErrors, key, newErrors[key])
            }
          })
        } else {
          this.authorErrors = newErrors
        }
      }
      return saveResponse
    },
    /**
     * Handle selected item that could be artist or vocaloid or author.
     * @param {string} data - selected entity's data.
     * @param {string} belongsTo - representing the entity
     * (e.g., artist, vocaloid, author) for which the current operation is being performed
     */
    handleSelectedDataFromChild({ data, belongsTo }) {
      const selectedArtist = { ...data }
      selectedArtist.isRemovable = true
      switch (belongsTo) {
        case MAIN_ARTIST: {
          this.copyRightForm.artists.main_artists.push(selectedArtist)
          this.onFieldChanged('artists.main_artists')
          this.filterOutSelectedData({ data, belongsTo })
          this.handleToggleAccordionAfterOperation(MAIN_ARTIST)
          break
        }
        case MAIN_ARTIST_VOCALOID:
          this.copyRightForm.artists.main_artists.push(selectedArtist)
          this.filterOutSelectedData({ data, belongsTo })
          this.handleToggleAccordionAfterOperation(MAIN_ARTIST_VOCALOID)
          break
        case FEATURING_ARTIST:
          this.copyRightForm.artists.featuring_artists.push(selectedArtist)
          this.filterOutSelectedData({ data, belongsTo })
          this.handleToggleAccordionAfterOperation(FEATURING_ARTIST)
          break
        case FEATURING_ARTIST_VOCALOID:
          this.copyRightForm.artists.featuring_artists.push(selectedArtist)
          this.filterOutSelectedData({ data, belongsTo })
          this.handleToggleAccordionAfterOperation(FEATURING_ARTIST_VOCALOID)
          break
        case AUTHOR: {
          const selAuthor = { ...data }
          selAuthor.pivot = {
            author_roles: this.getRoles(),
          }
          selAuthor.operation = NON_DISTRIBUTED_AUTHOR.POST_SELECTED_UI
          this.copyRightForm.authors.push(selAuthor)
          this.onFieldChanged('authors')
          this.selectedAuthors.push(JSON.stringify(selAuthor))
          const authorMeta = selAuthor.author_meta
          if (!authorMeta.is_owner) {
            this.selectedAuthorEmails.push(authorMeta.email)
          }
          this.filterOutSelectedData({ data, belongsTo })
          this.handleToggleAccordionAfterOperation(AUTHOR)
          if (this.copyRightForm.is_instrumental) {
            this.checkAndDisableLyricistAndCoLyricist()
            this.removeCheckedRolesIfInstrumentalChecked()
          }
          this.calculateRate()
          break
        }
        default:
      }
    },
    /**
     * Handle the cancel operation of author
     * @param {int} index - index of author
     */
    async handleCancelAuthor(index) {
      const author = this.copyRightForm.authors[index]
      if (this.deliveredTrackAuthor.includes(author.name_ja)) {
        this.copyRightForm.authors[index].isTrackAuthor = true
        this.copyRightForm.authors[index].operation = DISTRIBUTED_AUTHOR.POST_SAVE_UI
      } else {
        this.copyRightForm.authors[index].operation = NON_DISTRIBUTED_AUTHOR.POST_SAVE_UI
      }
      this.handleAuthorBeingEdited({ author, index, isCancelOperation: true })
    },
    /**
     * Handle the edit operation of author
     * @param {index} index - index of author
     */
    async handleEditAuthor(index) {
      const author = this.copyRightForm.authors[index]
      if (this.deliveredTrackAuthor.includes(author.name_ja)) {
        this.copyRightForm.authors[index].isTrackAuthor = true
        this.copyRightForm.authors[index].operation = DISTRIBUTED_AUTHOR.POST_EDIT_UI
      } else {
        this.copyRightForm.authors[index].operation = NON_DISTRIBUTED_AUTHOR.POST_EDIT_UI
      }
      this.editedAuthors.push(author)
    },
    /**
     * restore data in original data
     * @param {string} data - data to be restored
     */
    restoreData(data) {
      if (data.type === 3) {
        this.mainArtistVocaloidPagination.push(data)
        this.featuringArtistVocaloidPagination = this.mainArtistVocaloidPagination
      } else {
        this.mainArtistPagination.push(data)
        this.featuringArtistPagination = this.mainArtistPagination
      }
      this.handleFilterItems(ARTIST)
    },
    /**
     * return search status depending on data length and keyword
     * @param {object} data - data
     * @param {string} keyword - searched text
     */
    getSearchStatus(data, keyword) {
      // No results found and keyword is present
      if (data.length === 0 && keyword) {
        return 1
      }
      // No results found and no keyword
      if (data.length === 0 && !keyword) {
        return 0
      }
      // Results found
      return 2
    },
    /**
     * perform saving of form
     */
    async onNextClicked(key = null) {
      const config = { headers: { 'X-CMAP-No-Loading': 1 } }
      const originalAuthors = this.copyRightForm.authors
      try {
        // remove operation key from authors
        this.copyRightForm.authors = this.copyRightForm.authors
          .map(({ operation, ...rest }) => rest)
        if (this.isEditTrack) {
          this.copyRightForm.product_disc_track_id = this.$route.params.id
        }
        this.copyRightForm.deliveredTrackAuthor = this.deliveredTrackAuthor
        if (this.copyRightForm.id && !this.isEditTrack) {
          const endpoint = key ? `/api/client/copyrights/${this.copyRightForm.id}?form_validate_only=1` : `/api/client/copyrights/${this.copyRightForm.id}`
          const { data: response } = await window.axios.put(endpoint, this.copyRightForm, config)
          // During edit prevent transition of UI
          if (response && response.length === 0) {
            this.restoreOriginalAuthors(originalAuthors)
            this.errors = {}
            return
          }
        } else {
          const endpoint = key ? '/api/client/copyrights?form_validate_only=1' : '/api/client/copyrights'
          const { data: response } = await window.axios.post(endpoint, this.copyRightForm, config)
          // During edit prevent transition of UI
          if (response && response.length === 0) {
            this.restoreOriginalAuthors(originalAuthors)
            this.errors = {}
            return
          }
          this.copyRightForm.id = response.id
        }
        if (key) {
          this.errors = {}
        }
        this.$router.push({ name: 'copyright-confirm', params: { id: this.copyRightForm.id } })
      } catch ({ response }) {
        this.restoreOriginalAuthors(originalAuthors)
        const { errors } = response.data
        if (key && errors[key]) {
          this.$set(this.errors, key, errors[key])
        } else if (key && !errors[key]) {
          this.errors = {}
        } else {
          this.errors = errors
        }
      }
    },
    /**
     * handle the back button clicked operation
     */
    onReturnClicked() {
      this.$router.push({ name: 'copyright-index' })
    },
    async handleTabClicked({ belongsTo, index }) {
      switch (belongsTo) {
        case MAIN_ARTIST:
          this.activeTab = index
          if (this.activeTab === 0) {
            await this.getArtist()
          } else if (this.activeTab === 2) {
            this.isAddingForMainArtist = true
            this.mainArtistVocaloidPagination = []
            await this.getVocaloid()
          }
          break
        case FEATURING_ARTIST:
          this.activeFeaturingTab = index
          if (this.activeFeaturingTab === 0) {
            await this.getArtist()
          } else if (this.activeFeaturingTab === 2) {
            this.isAddingForFeaturingArtist = true
            this.featuringArtistVocaloidPagination = []
            await this.getVocaloid()
          }
          break
        case AUTHOR:
          this.activeAuthorTab = index
          if (this.activeAuthorTab === 0) {
            await this.getAuthors()
          }
          this.authorErrors = {}
          break
        default:
      }
    },
    // reset author form
    resetAuthorForm() {
      this.showAuthorAccordion = false
      this.authorForm = {
        id: '',
        name_ja: '',
        name_kana: '',
        name_en: '',
        author_meta: {
          is_group: false,
          is_owner: true,
          personal_meta: {
            real_name: {
              ja: { name: '' },
              en: { name: '' },
            },
            is_jasrac_member: false,
          },
          group_meta: [],
        },
        pivot: {
          author_roles: this.getRoles(),
        },
        operation: NON_DISTRIBUTED_AUTHOR.CREATE_UI,
        isTrackAuthor: false,
        rate: 0,
      }
    },
    getRoles() {
      return [
        {
          value: 'lyricist',
          label: '作詞',
          disabled: false,
          checked: false,
          rate: 0.5,
        },
        {
          value: 'composer',
          label: '作曲',
          disabled: false,
          checked: false,
          rate: 0.5,
        },
        {
          value: 'co-lyricist',
          label: '補作詞者',
          disabled: this.isCoLyricistSelected,
          checked: false,
          rate: 0.08333333333,
        },
        {
          value: 'co-composer',
          label: '補作曲者',
          disabled: this.isCoComposerSelected,
          checked: false,
          rate: 0.08333333333,
        },
      ]
    },
    async getArtist({ belongsTo = '', searchText = '', page = 0 } = {}) {
      const { data } = await window.axios.get('/api/client/artists', {
        params: {
          type: 1,
          page,
          count: 20,
          keyword: searchText,
          isPaginate: false,
        },
      })
      if (data.length === 0) {
        if (belongsTo === MAIN_ARTIST) {
          this.artistLastPage = true
        } else {
          this.featArtistLastPage = true
        }
      }
      if (belongsTo === MAIN_ARTIST) {
        this.mainArtistPagination = [...this.mainArtistPagination, ...data]
      } else if (belongsTo === FEATURING_ARTIST) {
        this.featuringArtistPagination = [...this.featuringArtistPagination, ...data]
      } else {
        this.mainArtistPagination = data
        this.featuringArtistPagination = data
      }
      this.mainSearchStatus = this.getSearchStatus(this.mainArtistPagination, searchText)
      this.featSearchStatus = this.getSearchStatus(this.featuringArtistPagination, searchText)
      this.handleFilterItems(ARTIST)
    },
    async getVocaloid({ belongsTo = '', searchText = '', page = 0 } = {}) {
      const { data } = await window.axios.get('/api/client/vocaloids', {
        params: {
          page,
          count: 20,
          keyword: searchText,
          isPaginate: false,
        },
      })
      if (data.length === 0) {
        if (belongsTo === MAIN_ARTIST_VOCALOID) {
          this.vocaloidLastPage = true
        } else {
          this.featVocaloidLastPage = true
        }
      }
      if (belongsTo === MAIN_ARTIST_VOCALOID) {
        this.mainArtistVocaloidPagination = [...this.mainArtistVocaloidPagination, ...data]
        this.filterMainArtistVocaloidData()
      } else if (belongsTo === FEATURING_ARTIST_VOCALOID) {
        this.featuringArtistVocaloidPagination = [
          ...this.featuringArtistVocaloidPagination,
          ...data]
        this.filterFeatArtistVocaloidData()
      } else {
        this.mainArtistVocaloidPagination = [...data]
        this.featuringArtistVocaloidPagination = [...data]
        this.filterMainArtistVocaloidData()
        this.filterFeatArtistVocaloidData()
      }
      this.mainSearchStatus = this.getSearchStatus(
        this.mainArtistVocaloidPagination,
        searchText,
      )
      this.featSearchStatus = this.getSearchStatus(
        this.featuringArtistVocaloidPagination,
        searchText,
      )
      this.handleFilterItems(VOCALOID)
    },
    async getAuthors({ searchText = '', page = 0 } = {}) {
      const { data } = await window.axios.get('/api/client/authors', {
        params: {
          page,
          count: this.authorPagination.per_page,
          keyword: searchText,
        },
      })
      this.authorPagination = data
      this.authorSearchStatus = this.getSearchStatus(this.authorPagination.data, searchText)
      this.handleFilterItems(AUTHOR)
    },
    async getCopyrights(id) {
      return window.axios.get('/api/client/copyrights', {
        params: {
          id,
        },
      })
    },
    /**
     * Get track details of the track id provided
     * @param id - Product disc track id
     * @returns {Promise<void>}
     */
    async getTrackDetails(id) {
      return window.axios.get(`/api/client/copyrights/tracks/${id}`, {
        params: {
          trackId: id,
          status: [CMAP_RELEASE_STATUS_PUBLISHED, CMAP_RELEASE_STATUS_DSP_IN_REVIEW],
        },
      })
    },
    /**
     * Change the instrumental radio button value
     * @param value
     */
    toggleInstrumentalCheckbox() {
      this.calculateRate()
    },
    isDeliveredTrack() {
      return this.copyRightForm.type === 0
    },
    filterMainArtistVocaloidData() {
      const filteredMainArtist = this.mainArtistVocaloidPagination
        .filter(vocaloid => vocaloid.display_division !== 3)
      // add an 'options' key-value pair that determines the overlay.
      this.mainArtistVocaloidPagination = filteredMainArtist.map(vocaloid => {
        const unavailableFeaturing = { options: { overlay: true, overlayText: 'フィーチャリングアーティストのみ選択可能' } }
        const available = { options: { overlay: false, overlayText: '' } }
        if (this.isAddingForMainArtist && vocaloid.display_division === 2) {
          return { ...vocaloid, ...unavailableFeaturing }
        }
        return { ...vocaloid, ...available }
      })
      return this.mainArtistVocaloidPagination
    },
    filterFeatArtistVocaloidData() {
      const filteredfeaturingArtist = this.featuringArtistVocaloidPagination
        .filter(vocaloid => vocaloid.display_division !== 3)
      // add an 'options' key-value pair that determines the overlay.
      this.featuringArtistVocaloidPagination = filteredfeaturingArtist.map(vocaloid => {
        const unavailableMain = { options: { overlay: true, overlayText: 'メインアーティストのみ選択可能' } }
        const available = { options: { overlay: false, overlayText: '' } }
        if (this.isAddingForFeaturingArtist && vocaloid.display_division === 1) {
          return { ...vocaloid, ...unavailableMain }
        }
        return { ...vocaloid, ...available }
      })
      return this.featuringArtistVocaloidPagination
    },
    handlePagination({ page, belongsTo }) {
      switch (belongsTo) {
        case MAIN_ARTIST:
        case FEATURING_ARTIST:
          this.getArtist({ belongsTo, page })
          break
        case MAIN_ARTIST_VOCALOID:
        case FEATURING_ARTIST_VOCALOID:
          this.getVocaloid({ belongsTo, page })
          break
        case AUTHOR:
          this.getAuthors({ page })
          break
        default:
      }
    },
    handleAuthorBeingEdited({ author, index = 0, isCancelOperation = false }) {
      const editedAuthor = this.editedAuthors
      const eIndex = editedAuthor.findIndex(eAuthor => eAuthor.name_ja === author.name_ja)
      if (eIndex !== -1) {
        editedAuthor.splice(eIndex, 1)
      }
      if (isCancelOperation) {
        const sAuthor = this.selectedAuthors
        const sIndex = sAuthor
          .findIndex(curAuthor => JSON.parse(curAuthor).name_ja === author.name_ja)
        if (sIndex !== -1) {
          this.copyRightForm.authors[index].author_meta = JSON.parse(sAuthor[sIndex]).author_meta
        }
      }
    },
    handleButtonMousedown(event) {
      event.preventDefault()
    },
    // in case of errors restore original authors having operation key
    restoreOriginalAuthors(originalAuthors) {
      this.copyRightForm.authors = originalAuthors
    },
    deleteAuthorError(pattern) {
      if (Object.keys(this.authorErrors).length === 0) {
        this.authorErrors = {}
        this.trackAlreadyActiveAuthorFormFields = []
      } else {
        const errors = { ...this.authorErrors }
        Object.keys(errors).forEach(key => {
          if (key.startsWith(pattern)) {
            delete errors[key]
          }
          this.trackAlreadyActiveAuthorFormFields = this.trackAlreadyActiveAuthorFormFields
            .filter((element) => element !== key)
        })
        this.authorErrors = { ...errors }
      }
    },
    /**
     * Handles the updated value of the field.
     * @param {string} field - The name of the field whose value is changed.
     * @param {int} index - The current index of the author whose value was changed.
     * @param {boolean} value - changed value.
     * @param {string} belongsTo - to track if personal_meta or group_meta key are changed.
     */
    handleValueUpdate({
      field,
      index,
      value,
      belongsTo,
    }) {
      if (belongsTo === 'personal_meta') {
        this.copyRightForm.authors[index].author_meta.personal_meta[field] = value
      } else if (belongsTo === 'group_meta') {
        this.copyRightForm.authors[index].author_meta.group_meta[field] = value
      } else {
        this.copyRightForm.authors[index].author_meta[field] = value
      }
    },
    handleAuthorRolesUpdate({ index, role }) {
      this.updateAuthorRoles(index, role)
      this.calculateRate()
    },
    updateAuthorRoles(index, selectedRole) {
      const author = this.copyRightForm.authors[index]
      const checkedRole = author.pivot.author_roles
        .find(currentRole => currentRole.value === selectedRole.value)
      checkedRole.checked = !checkedRole.checked
      if (selectedRole.value === 'lyricist' && !this.isCoLyricistSelected) {
        const coLyricist = author.pivot.author_roles
          .find(currentRole => currentRole.value === 'co-lyricist')
        coLyricist.disabled = !!checkedRole.checked
      }

      if (selectedRole.value === 'composer' && !this.isCoComposerSelected) {
        const coComposer = author.pivot.author_roles
          .find(currentRole => currentRole.value === 'co-composer')
        coComposer.disabled = !!checkedRole.checked
      }

      if (selectedRole.value === 'co-lyricist') {
        const lyricist = author.pivot.author_roles
          .find(currentRole => currentRole.value === 'lyricist')
        lyricist.disabled = !!checkedRole.checked
        this.isCoLyricistSelected = !!checkedRole.checked
      }

      if (selectedRole.value === 'co-composer') {
        const composer = author.pivot.author_roles
          .find(currentRole => currentRole.value === 'composer')
        composer.disabled = !!checkedRole.checked
        this.isCoComposerSelected = !!checkedRole.checked
      }

      this.copyRightForm.authors[index] = author
    },
    checkAndDisableLyricistAndCoLyricist() {
      /* eslint-disable camelcase */
      const { authors, is_instrumental } = this.copyRightForm
      authors.forEach((author, index) => {
        authors[index].pivot = {
          ...author.pivot,
          author_roles: author.pivot.author_roles.map(role => {
            if (role.value === 'lyricist' || role.value === 'co-lyricist') {
              return { ...role, disabled: is_instrumental }
            }
            return role
          }),
        }
      })
      /* eslint-enable camelcase */
    },
    removeCheckedRolesIfInstrumentalChecked() {
      /* eslint-disable camelcase */
      const { authors, is_instrumental } = this.copyRightForm
      authors.forEach((author, index) => {
        authors[index].pivot = {
          ...author.pivot,
          author_roles: author.pivot.author_roles.map(role => {
            if (role.value === 'co-lyricist' || role.value === 'lyricist') {
              return { ...role, disabled: is_instrumental, checked: false }
            }
            return role
          }),
        }
      })
      /* eslint-enable camelcase */
    },
    calculateRate() {
      /* eslint-disable camelcase */
      const { authors, is_instrumental } = this.copyRightForm

      // Step 1: Calculate occurrences of each role
      let lyricistCount = 0
      let composerCount = 0
      let lyricistCoComposerCount = 0
      let lyricistCoLyricistCount = 0

      authors.forEach(author => {
        const roles = author.pivot.author_roles
        if (roles.some(role => role.value === 'lyricist' && role.checked)
          && roles.some(role => role.value === 'composer' && role.checked)
        ) {
          lyricistCount += 1
          composerCount += 1
        } else if (roles.some(role => role.value === 'lyricist' && role.checked)) {
          // lyricist checked
          lyricistCount += 1
          if (roles.some(role => role.value === 'co-composer' && role.checked)) {
            lyricistCoComposerCount += 1
          }
        } else if (roles.some(role => role.value === 'composer' && role.checked)) {
          composerCount += 1
          if (roles.some(role => role.value === 'co-lyricist' && role.checked)) {
            lyricistCoLyricistCount += 1
          }
        } else if (roles.some(role => role.value === 'lyricist' && !role.checked)
          && roles.some(role => role.value === 'composer' && !role.checked)
        ) {
          // co-lyricist checked
          if (roles.some(role => role.value === 'co-lyricist' && role.checked)) {
            lyricistCoLyricistCount += 1
          }
          // co-composer checked
          if (roles.some(role => role.value === 'co-composer' && role.checked)) {
            lyricistCoComposerCount += 1
          }
        }
      })
      authors.forEach(author => {
        const roles = author.pivot.author_roles
        const checkedRoles = roles.filter(role => role.checked)
        const checkedRoleNames = roles
          .filter(role => role.checked)
          .map(role => role.value)
        let rate = 0
        let lyricistRate = is_instrumental ? 12 : 6
        let composerRate = is_instrumental ? 12 : 6
        if (lyricistCoLyricistCount) {
          lyricistRate -= 1
        }
        if (lyricistCoComposerCount) {
          composerRate -= 1
        }
        checkedRoles.forEach(checkedRole => {
          if (lyricistCount >= 1 && checkedRole.value === 'lyricist') {
            rate += (lyricistRate / lyricistCount) / 12
          }
          if (composerCount >= 1 && checkedRole.value === 'composer') {
            rate += (composerRate / composerCount) / 12
          }
          if (checkedRoleNames.includes('co-composer') && lyricistCoComposerCount === 1 && checkedRole.value === 'co-composer') {
            rate += 1 / 12
          }
          if (checkedRoleNames.includes('co-lyricist') && lyricistCoLyricistCount === 1 && checkedRole.value === 'co-lyricist') {
            rate += 1 / 12
          }
        })
        /* eslint-disable no-param-reassign */
        author.rate = rate
        /* eslint-enable no-param-reassign */
      })
      // Step 3: Calculate rate for each author
      /* eslint-disable no-param-reassign */
      this.copyRightForm.authors = authors.map(author => ({ ...author, rate: author.rate * 100 }))
      /* eslint-enable no-param-reassign */
      /* eslint-enable camelcase */
    },
    retrieveSelectedAuthorsEmail() {
      const { authors } = this.copyRightForm
      if (authors.length === 0) return
      authors.forEach((author) => {
        const authorMeta = author.author_meta
        if (!authorMeta.is_owner) {
          this.selectedAuthorEmails.push(authorMeta.email)
        }
      })
    },
    isEnabledCopyrightOperation() {
      return this.$store.state.auth.enable_copyright_operation
    },
    getButtonText(key) {
      if (key && key === 'main_artists') {
        return this.copyRightForm && this.copyRightForm.artists.main_artists.length > 0
          ? 'メインアーティストを追加する'
          : 'メインアーティストを登録する'
      }
      if (key && key === 'featuring_artists') {
        return this.copyRightForm && this.copyRightForm.artists.featuring_artists.length > 0
          ? 'フィーチャリングアーティストを追加する'
          : 'フィーチャリングアーティストを登録する'
      }
      if (key && key === 'authors') {
        return this.copyRightForm && this.copyRightForm.authors.length > 0
          ? '著作者を追加する'
          : '著作者を登録する'
      }
      return ''
    },
    handleNoFeaturingArtists() {
      this.copyRightForm.artists.featuring_artists = []
      this.getArtist()
    },
  },
}
</script>

<style scoped>
.accordion button {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 60px;
  margin: 4px 0 4px 0;
  cursor: pointer;
  background-color: #DEDEDE;
  color: #333;
  font-weight: bold;
}

.accordion button.active {
  background-color: #d5d3e1;
  height: 72px;
  margin: 0 4px 0 4px;
  color: #ff2289;
  border: 1px solid #c4c4c4;
}
.form-control--time {
  width: 65px !important;
}
.delivered-song-label {
  position: absolute;
  right: 20px;
  height: 35px;
  width: 120px;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: white;
  padding: 7px 0 2px 0;
  margin: 0;
  background-color: #4bc1f2;
}

@media screen and (min-width: 896px) {
  .not-distributed-apply {
    min-width: 896px;
    max-width: 896px;
  }
}

@media screen and (max-width: 895px) {
  .not-distributed-apply {
    max-width: 896px;
  }

  .instrumental-checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 15px;
  }
}

@media screen and (min-width: 896px) {
  .checkbox {
    display: inline-block;
    margin-right: 35px;
  }
}

@media screen and (max-width: 895px) {
  .checkbox {
    font-size: 3.2vw;
    margin-right: 2vw;
  }
  .radio label {
    font-size: 17px;
  }
  .form-control--time {
    width: 45px !important;
    font-size: 16px;
  }
}

.author-section{
    background-color: white;
    padding: 20px;
}

.form-group-wrap__title span {
    display: inline-block;
    margin-left: 0 !important;
}
.form-group-wrap__title .tooltip-icon {
  margin-left: 10px !important;
}

.sub-text {
  font-weight: normal;
  color: gray;
}

.heading {
  font-size: 20px;
  margin-top: 2%;
  font-weight: 500;
}
.disabled-checkbox::before {
  background-color: #c0c0c0;
}
.disabled-checkbox::after {
  background-color: #c0c0c0;
}
</style>
